import { ApiPaths } from "../../api/ApiPaths";
import { CareRecipientId } from "../../../domain/care_recipient/CareRecipientId";
import { ApiRequest } from "../../api/ApiRequest";
import { CareRecipient } from "../../../domain/care_recipient/CareRecipient";
import { format } from "date-fns";

export type GetListSuccessResponseType = {
    careRecipients: [{
        id: string,
        name: string,
        houseId: string | null
        alertPeriod: {
            start: string,
            end: string
        } | null,
        branchCode: string | null,
        customerCode: string | null,
    }],
    // API処理結果判別用：OK->undefined、NG->ErrorResponseType
    error: undefined
}

export async function getList(): Promise<GetListSuccessResponseType> {
    return await ApiRequest.get(
        ApiPaths.careRecipient.list,
        {},
        () => {},
        () => {});
}

export type GetInformationSuccessResponseType = {
    id: string,
    name: string,
    birthday: string,
    houseId: string | null,
    customerCode: string | null,
    branchCode: string | null,
    // API処理結果判別用：OK->undefined、NG->ErrorResponseType
    error: undefined
}

export async function getInformation(
    careRecipientId: CareRecipientId
): Promise<GetInformationSuccessResponseType> {
    return await ApiRequest.get(
        `${ApiPaths.careRecipient.information}/${careRecipientId.value}`,
        {},
        () => {},
        () => {});
}

export type GetSupporterListSuccessResponseType = {
    users: [{
        id: string,
        name: string,
        role: string
    }],
    // API処理結果判別用：OK->undefined、NG->ErrorResponseType
    error: undefined
}

export async function getSupporterList(
    careRecipientId: CareRecipientId
): Promise<GetSupporterListSuccessResponseType> {
    return await ApiRequest.get(
        ApiPaths.user.supporterList,
        {
            care_recipient_id: careRecipientId.value
        },
        () => {},
        () => {});
}

export async function registerCareRecipient(
    name: string,
    customerCode: string,
    birthday: Date | null,
    successHandler: () => void,
    failureHandler: (response: Response) => void,
): Promise<CareRecipient> {
    return await ApiRequest.post(
        "/api/care_recipient",
        {},
        {
            name: name,
            customerCode: customerCode,
            birthday: birthday ? format(birthday, "yyyy-MM-dd") : null,
        },
        successHandler,
        failureHandler);
}

